import gsap from 'gsap'
import barba from '@barba/core'
import lottieWeb from 'lottie-web'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Animations } from './animation'
import { Navigation } from './navigation'
import { splitType } from './splitType'
import { initLenis, scrollToStart, scrollTo } from './lenis'
import { initAlpine } from './alpine'
import { initForms } from './formie'
import { initSwiper } from './swiper'
import { initBenefits } from './benefits'
import { galleryLayout } from './gallery'
import { Announcement } from './animation'
import { knowledgeHub } from './knowledgeHub'
import { popup } from './popup'
import { trustindex } from './trustindex'
import { runCharts } from './chart'
import { addParams } from './utmTracking'
import { setHeaderColour, refreshScripts, autoplayVideos, refreshTrustpilotWidget } from './utilities'

gsap.registerPlugin(ScrollTrigger)

const initBarba = () => {

	const nav = new Navigation()
	const transitionLogo = document.querySelector('.transition__animation')
	const anim = lottieWeb.loadAnimation({
		container: transitionLogo,
		loop: false,
		autoplay: false,
		renderer: 'svg',
		path: '/lottie/loader.json',
		rendererSettings: {
			progressiveLoad: true
		}
	})

	barba.init({
		debug: false,
		timeout: 10000,
		schema: {
			prefix: 'data-load'
		},
		transitions: [
			{
				name: 'basic-transition',
				once(data) { },
				leave(data) {
					const done = this.async()
					const tl = gsap.timeline({ onComplete: done })
					const transition = document.querySelector('.transition')
 
					anim.playSegments([[0, 48], [48, 0], [0, 48], [48, 0]], true)

					tl.set(transition, { clipPath: 'polygon(25% 100%, 75% 100%, 100% 100%, 100% 100%, 0 100%, 0 100%)' })
					tl.to(transition, { 
						duration: 0.7,
						ease: 'power3.in',
						clipPath: 'polygon(25% 50%, 75% 50%, 100% 80%, 100% 100%, 0 100%, 0 80%)'
					}, 0)
					tl.to(transition, { 
						duration: 0.7,
						ease: 'power3.out',
						clipPath: 'polygon(25% 0%, 75% 0%, 100% 0%, 100% 100%, 0 100%, 0 0%)'
					})
				},
				afterLeave() {
					scrollToStart()
					nav.setActiveState()
					nav.closeNavigation()
					ScrollTrigger.getAll().forEach(t => t.kill())
				},
				after(data) {
					const done = this.async()
					const tl = gsap.timeline({ onComplete: () => {
						done()
						anim.stop()
					} })
					const transition = document.querySelector('.transition')
					
					tl.set(transition, { clipPath: 'inset(0 0 0% 0)' })
					tl.to(transition, { 
						duration: 1.2,
						ease: 'power4.inOut',
						clipPath: 'inset(0 0 100% 0)'
					}, 0)
				}
			}
		]
	})

	barba.hooks.once((data) => {
		initLenis()
		initAlpine()
		initSwiper()
		initBenefits()
		splitType()
		galleryLayout()
		Animations()
		Announcement()
		knowledgeHub()
		runCharts()
		setHeaderColour(data.next.container)
		scrollTo()
		popup()
	})

	barba.hooks.enter((data) => {
		htmx.process(data.next.container)
		setHeaderColour(data.next.container)
	})

	barba.hooks.after((data) => {
		initSwiper()
		initForms()
		initBenefits()
		splitType()
		galleryLayout()
		Animations()
		knowledgeHub()
		trustindex()
		scrollTo()
		runCharts()
		addParams()
		refreshScripts(data.next.container)
		autoplayVideos(data.next.container)
		refreshTrustpilotWidget(data.next.container)
	})
}

export default initBarba